interface QualityScorecardProps {
  incomingRate?: number;
  inProcessRate?: number;
  finalRate?: number;
  openNCRs?: number;
  openCAPAs?: number;
}

export default function QualityScorecard({
  incomingRate = 100,
  inProcessRate = 100,
  finalRate = 100,
  openNCRs = 0,
  openCAPAs = 0,
}: QualityScorecardProps) {
  const rows = [
    { label: 'Incoming Inspection Pass Rate', value: `${incomingRate}%`, target: 95, pct: incomingRate },
    { label: 'In-Process Quality Pass Rate', value: `${inProcessRate}%`, target: 95, pct: inProcessRate },
    { label: 'Final Quality Pass Rate', value: `${finalRate}%`, target: 95, pct: finalRate },
  ];

  return (
    <div className="bg-white border border-[#e2e8f0] rounded-xl p-5">
      <h3 className="text-sm font-semibold text-[#1e293b] mb-4 flex items-center gap-2">
        <i className="ri-verified-badge-line text-emerald-500" />
        Quality Scorecard
      </h3>

      <div className="space-y-3 mb-4">
        {rows.map((r) => (
          <div key={r.label}>
            <div className="flex items-center justify-between mb-1">
              <span className="text-xs text-[#475569]">{r.label}</span>
              <span className={`text-xs font-semibold ${r.pct >= r.target ? 'text-emerald-600' : 'text-amber-600'}`}>
                {r.value}
              </span>
            </div>
            <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden">
              <div
                className={`h-full rounded-full ${r.pct >= r.target ? 'bg-emerald-400' : 'bg-amber-400'}`}
                style={{ width: `${Math.min(100, Math.max(0, r.pct))}%` }}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-3 pt-3 border-t border-[#f1f5f9]">
        <div className="flex flex-col items-center p-2.5 rounded-lg bg-slate-50">
          <span className={`text-lg font-bold ${openNCRs > 0 ? 'text-red-600' : 'text-emerald-600'}`}>
            {openNCRs}
          </span>
          <span className="text-xs text-[#64748b] mt-0.5">Open NCRs</span>
        </div>
        <div className="flex flex-col items-center p-2.5 rounded-lg bg-slate-50">
          <span className={`text-lg font-bold ${openCAPAs > 0 ? 'text-amber-600' : 'text-emerald-600'}`}>
            {openCAPAs}
          </span>
          <span className="text-xs text-[#64748b] mt-0.5">Open CAPAs</span>
        </div>
      </div>
    </div>
  );
}
